var map = {
	"./Achievement.svg": "9d82",
	"./AddressInfo.svg": "494f",
	"./ApprovalForms.svg": "3213",
	"./Attendance.svg": "10de",
	"./Badge.svg": "e247",
	"./Bank&Finance/Accounting.svg": "c873",
	"./Bank&Finance/Bank.svg": "2fb1",
	"./Bank&Finance/Currency.svg": "88fa",
	"./Bank&Finance/CustomerService.svg": "1013",
	"./Bank&Finance/DealsMoney.svg": "da5a",
	"./Bank&Finance/Deposit.svg": "828f",
	"./Bank&Finance/DigitalCommerce.svg": "84dc",
	"./Bank&Finance/Exchange.svg": "9a3f",
	"./Bank&Finance/FundingPlatform.svg": "a1fb",
	"./Bank&Finance/Growth.svg": "babd",
	"./Bank&Finance/InterestRate.svg": "d8f4",
	"./Bank&Finance/MarketingResearch.svg": "c768",
	"./Bank&Finance/MobileMarketing.svg": "709c",
	"./Bank&Finance/MoneyManagement.svg": "9cf5",
	"./Bank&Finance/Savings.svg": "da11",
	"./Bank&Finance/Statistics.svg": "3a12",
	"./Bank&Finance/TimeManagement.svg": "77c6",
	"./BestEmployee.svg": "117b",
	"./Billing.svg": "ce1d",
	"./Bug Tracker.svg": "f4a5",
	"./Calendar.svg": "8c11",
	"./Certificate.svg": "5d50",
	"./Chart.svg": "816c",
	"./Check.svg": "8250",
	"./Clients.svg": "dd95",
	"./ContactBook.svg": "e45d",
	"./ContactInfo.svg": "3297",
	"./Contacts copy.svg": "810d",
	"./Contacts.svg": "a14a",
	"./Contract.svg": "6797",
	"./Contractor.svg": "10f0",
	"./Cooperation.svg": "6436",
	"./Custom Dashboard.svg": "8fd9",
	"./Customer.svg": "fe83",
	"./CustomerInfo.svg": "1826",
	"./Dashboard copy.svg": "770e",
	"./Default.svg": "186a",
	"./Documentation.svg": "40b2",
	"./Documents copy.svg": "942a",
	"./Documents.svg": "2aff",
	"./Education Icon.svg": "2631",
	"./Education/Good.svg": "ffa6",
	"./Education/HrmCompany.svg": "84af",
	"./Education/HrmDepartment.svg": "4cac",
	"./Education/LeaveManagement.svg": "e67b",
	"./Education/Management.svg": "0ca3",
	"./Education/Meeting.svg": "16e3",
	"./Education/MultipleUser.svg": "bbdb",
	"./Education/Notes.svg": "6ab7",
	"./Education/Onboarding.svg": "91f1",
	"./Education/OnlineEvent.svg": "4597",
	"./Education/PerformanceManagement.svg": "8f4a",
	"./Education/Planning.svg": "7b02",
	"./Education/Productivity.svg": "03a4",
	"./Education/Projects&Timesheets.svg": "eba9",
	"./Education/Promotion.svg": "e8eb",
	"./Education/Relationship.svg": "791a",
	"./Education/SalarySlipManagement.svg": "86ac",
	"./Education/Services.svg": "676c",
	"./Education/SkillDevelopment.svg": "2062",
	"./Education/SkillSession.svg": "f47e",
	"./Education/TeamBuilding.svg": "3c5a",
	"./Education/TeamManagement.svg": "7d6d",
	"./Education/TeamResult.svg": "9624",
	"./Education/TeamWork.svg": "a221",
	"./Education/TimeManagement.svg": "fb3d8",
	"./Education/VirtualBiometric.svg": "b8ae",
	"./Education/WorkPolicy.svg": "0ac4",
	"./Email.svg": "9c8a",
	"./Employee.svg": "e4f4",
	"./EmployeeCV.svg": "12b4",
	"./Entities Inactive.svg": "d4b6",
	"./EntitiesActive.svg": "ce29",
	"./Envelope.svg": "101d",
	"./Event.svg": "eb29",
	"./File.svg": "06e3",
	"./Flyer.svg": "e24c",
	"./FolderFile.svg": "6842",
	"./Form.svg": "e4f8",
	"./FormTemplates.svg": "e72e",
	"./Form_Inactive.svg": "c9d9",
	"./Form_active.svg": "97b7",
	"./Global Variable.svg": "8a16",
	"./Graduated.svg": "594e",
	"./Groups.svg": "6674",
	"./Headhunter.svg": "578e",
	"./Health.svg": "5d1e",
	"./Home.svg": "2c85",
	"./Hospital.svg": "e06d",
	"./Hospital/Ambulance.svg": "abed",
	"./Hospital/Diagnostic.svg": "7844",
	"./Hospital/Doctor.svg": "6280",
	"./Hospital/Eye Contrast.svg": "4917",
	"./Hospital/Hospital.svg": "bf2f",
	"./Hospital/Medical Examination.svg": "9779",
	"./Hospital/Medical Insurance.svg": "a3da",
	"./Hospital/Medical Stuff.svg": "3f78",
	"./Hospital/Medical.svg": "9290",
	"./Hospital/Neonatology-1.svg": "5943",
	"./Hospital/Neonatology.svg": "2a1e",
	"./Hospital/Online Consultation.svg": "71c8",
	"./Hospital/Online Medical Report.svg": "6919",
	"./Hospital/Oxygen.svg": "be95",
	"./Hospital/Patient Report.svg": "1bc9",
	"./Hospital/Pediatrics.svg": "f623",
	"./Hospital/Radiology.svg": "e077",
	"./Hospital/Sugar Checking.svg": "129e",
	"./Hospital/Surgery.svg": "d1f5",
	"./Hospital/Temperature.svg": "8a09",
	"./Hospital/Tomography.svg": "74ab",
	"./Hospital/patient.svg": "29b4",
	"./Hospital/stethoscope.svg": "051d",
	"./Identity.svg": "0c8d",
	"./Immigration.svg": "955f",
	"./Insurance.svg": "9eb1",
	"./Investment.svg": "4ba5",
	"./Invoice.svg": "6164",
	"./JobApplication.svg": "0671",
	"./JobInfo.svg": "6f4fa",
	"./JobInterview-1.svg": "4553",
	"./JobInterview.svg": "ce49",
	"./JobOpportunities.svg": "e215",
	"./JobSeeker.svg": "5de0",
	"./Joboffer.svg": "5138",
	"./Location.svg": "9b07",
	"./Logistics/Arrival Data.svg": "142e",
	"./Logistics/Cargo.svg": "f25e",
	"./Logistics/Check List.svg": "1348",
	"./Logistics/Communication.svg": "cc90",
	"./Logistics/Directions.svg": "7cbf",
	"./Logistics/Drone Shipping.svg": "b966",
	"./Logistics/Fragile Things-1.svg": "f6de",
	"./Logistics/Fragile Things.svg": "3f7a",
	"./Logistics/Lifting Order.svg": "1e9d",
	"./Logistics/Logistic.svg": "49aa",
	"./Logistics/Machine.svg": "f258",
	"./Logistics/Order NetWork.svg": "90ac",
	"./Logistics/Order.svg": "f71b",
	"./Logistics/Spirituality.svg": "0662",
	"./Logistics/Storage.svg": "2296",
	"./Logistics/Trucking.svg": "cb18",
	"./Manufacturing/Choosing.svg": "c66f",
	"./Manufacturing/Delivery.svg": "d2a3",
	"./Manufacturing/Engineers.svg": "110d",
	"./Manufacturing/Insoles.svg": "3a3d",
	"./Manufacturing/Installation.svg": "2669",
	"./Manufacturing/Laser.svg": "a5cf",
	"./Manufacturing/Machines.svg": "8928",
	"./Manufacturing/Marketing.svg": "1d7b",
	"./Manufacturing/Packaging-1.svg": "d098",
	"./Manufacturing/Packaging-2.svg": "fe8a",
	"./Manufacturing/Packaging.svg": "0b81",
	"./Manufacturing/Sketching.svg": "c0afb",
	"./Manufacturing/Turning.svg": "04a0",
	"./Manufacturing/Weightage.svg": "9e99",
	"./Manufacturing/Workers.svg": "a740",
	"./Marketplace.svg": "5f7b",
	"./MultipleUsers.svg": "b959",
	"./NewEmployee.svg": "5fab",
	"./Notes.svg": "36d4",
	"./Officebuilding.svg": "dda8",
	"./Officechair.svg": "495c",
	"./Payments.svg": "2958",
	"./PayrollInfo.svg": "a6c2",
	"./PersonalData.svg": "a62e",
	"./PersonalDetails.svg": "2324",
	"./Photo.svg": "5d88",
	"./Portfolio.svg": "0228",
	"./Profile.svg": "df95",
	"./Property/Building.svg": "99c0",
	"./Property/Check.svg": "5236",
	"./Property/Construct.svg": "c360",
	"./Property/Consultation.svg": "fdb4",
	"./Property/Dealings.svg": "2e10",
	"./Property/Document.svg": "79ea",
	"./Property/Documents.svg": "55f8",
	"./Property/Encashment.svg": "625d",
	"./Property/Exchange.svg": "0aad",
	"./Property/House Sale.svg": "00cc",
	"./Property/House Searching.svg": "39db",
	"./Property/House.svg": "5af3",
	"./Property/Insurance.svg": "3304",
	"./Property/Location House.svg": "a54a",
	"./Property/Lock.svg": "cc5f",
	"./Property/Mortgage.svg": "43a9",
	"./Property/Owner.svg": "b8e5",
	"./Property/Property Hands.svg": "f734",
	"./Property/Property List.svg": "e2e5",
	"./Property/Property Location.svg": "215f",
	"./Property/Property Man.svg": "f6e6",
	"./Property/Salesman.svg": "9c70",
	"./Property/Search Property.svg": "40ef",
	"./Property/Search.svg": "8ce3",
	"./Property/Secure key.svg": "5d4d",
	"./Property/Sold.svg": "ac87",
	"./Property/Tax Payment.svg": "a299",
	"./Property/Transactions.svg": "e3bd",
	"./Property/View Property.svg": "eb1a",
	"./Salary.svg": "cc83",
	"./Skill.svg": "50f1",
	"./Staffing/Chart.svg": "98ac",
	"./Staffing/Check.svg": "12d8",
	"./Staffing/Documents.svg": "dbdf",
	"./Staffing/Educate.svg": "4e75",
	"./Staffing/Employee.svg": "a41b",
	"./Staffing/Network.svg": "e4ea",
	"./Staffing/Raising Staff.svg": "6bd5",
	"./Staffing/Scheduled Time.svg": "7787",
	"./Staffing/Search Staff.svg": "0adf",
	"./Staffing/Staff Call.svg": "fc84",
	"./Staffing/Staff Group.svg": "5aca",
	"./Staffing/Staff Management.svg": "70c3",
	"./Staffing/Stuffing Level.svg": "bc51",
	"./Staffing/Team Work.svg": "1900",
	"./Staffing/Work.svg": "d2f7",
	"./Support.svg": "dc09",
	"./Templates copy.svg": "d474",
	"./Templates.svg": "f2d8",
	"./TermsConditions.svg": "cbb3",
	"./Travel/Checking.svg": "f17c",
	"./Travel/Collect Money.svg": "5c70",
	"./Travel/Confirm Message.svg": "9e30",
	"./Travel/Display Time Board.svg": "f68f5",
	"./Travel/Genrate Ticket.svg": "ce7c",
	"./Travel/Location.svg": "7739",
	"./Travel/Man.svg": "91c5",
	"./Travel/Metal Detector.svg": "c15d",
	"./Travel/Online Ticket.svg": "e7e4",
	"./Travel/Passport.svg": "d355",
	"./Travel/Refund Money.svg": "53bd",
	"./Travel/Ticket Checking.svg": "d928",
	"./Travel/Ticket Counters.svg": "b9e4",
	"./Travel/Verify.svg": "d6da",
	"./Travel/Waiting Passengers.svg": "e608",
	"./Trophy.svg": "0818",
	"./Vendor.svg": "3ed9",
	"./Verification.svg": "5bf7",
	"./Visa.svg": "7afe",
	"./Workflows.svg": "aa2b",
	"./Working.svg": "8a89",
	"./bell-icon.svg": "54bc",
	"./benefits-2.svg": "5157",
	"./benefits.svg": "cd1d",
	"./company-document-2.svg": "3f20",
	"./company-document.svg": "5d11",
	"./company-onboarding.svg": "3b90",
	"./company-templates-2.svg": "467fa",
	"./company-templates.svg": "3f64",
	"./contact_active.svg": "b7aa",
	"./contracts.svg": "d08d",
	"./create_document.svg": "11a7",
	"./dashboard.svg": "bc91",
	"./dashboard_active.svg": "329a",
	"./data-variable copy.svg": "db8d",
	"./data-variable.svg": "d16a8",
	"./documents_active.svg": "f6d8",
	"./employee-documents.svg": "7e4d",
	"./employee-list.svg": "7ae17",
	"./employess.svg": "fa99",
	"./entities.svg": "7986",
	"./file-manageer.svg": "2919",
	"./menu-1.svg": "cd81",
	"./menu-2.svg": "6b3d",
	"./menu-3.svg": "3e924",
	"./menu-4.svg": "d4a5",
	"./menu-5.svg": "d6b7",
	"./menu-6.svg": "2bda",
	"./menu-7.svg": "22e2",
	"./menu-8.svg": "b0a7",
	"./menu-configuration.svg": "003e",
	"./no-signature.svg": "f891",
	"./notifications.svg": "b357a",
	"./offer-letter.svg": "8a90",
	"./onboarding.svg": "7f0b",
	"./onlineresume.svg": "16df",
	"./request-document.svg": "458f",
	"./request-document_active.svg": "59802",
	"./settings.svg": "63cb",
	"./templates_active.svg": "64d3",
	"./user.svg": "1c16",
	"./variables.svg": "e371",
	"./work-flow.svg": "c3d2",
	"./workflow_active.svg": "da9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d69c";